import React from "react";
import { motion } from "framer-motion";
import { Footprints, Car, MapPin } from "lucide-react";
import { VILLA } from "../data";

const PLACES = [
    { name: "Fernandina Beach", time: "3 min", mode: "walk" },
    { name: "Main Beach Park", time: "8 min", mode: "walk" },
    { name: "Fort Clinch State Park", time: "14 min", mode: "walk" },
    { name: "Jacksonville Intl. (JAX)", time: "44 min", mode: "drive" },
];

export default function Location() {
    return (
        <section id="location" className="py-24 lg:py-36 bg-[#FAF8F5]" data-testid="location-section">
            <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
                <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
                    <p className="text-xs uppercase tracking-[0.3em] text-[#C49A45] font-semibold">Amelia Island living</p>
                    <h2 className="font-serif-d font-light text-4xl sm:text-5xl lg:text-6xl text-[#0F2837] mt-4 leading-[1.05]">
                        Close to everything.<br /><em className="text-[#2D6A76]">Far from ordinary.</em>
                    </h2>
                    <p className="mt-6 text-[#5C6A78] leading-relaxed max-w-lg">
                        From a morning walk to Fernandina Beach to an afternoon at Fort Clinch, the villa keeps the island's shoreline, parks and town within easy reach.
                    </p>
                    <div className="mt-6 flex items-start gap-3 rounded-2xl border border-[#E5DCCB] bg-white p-5 max-w-lg" data-testid="location-address">
                        <MapPin size={18} className="text-[#C49A45] mt-0.5 shrink-0" />
                        <div>
                            <p className="font-semibold text-[#0F2837] text-sm">{VILLA.address}</p>
                            <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(VILLA.address)}`} target="_blank" rel="noreferrer"
                                className="text-xs text-[#2D6A76] underline underline-offset-2 mt-1 inline-block" data-testid="location-map-link">
                                View in Google Maps →
                            </a>
                        </div>
                    </div>
                </motion.div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="location-distances">
                    {PLACES.map((p, i) => (
                        <motion.div key={p.name}
                            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                            className="rounded-3xl bg-[#0F2837] text-white p-7 hover:bg-[#1B3F56] transition-colors duration-300"
                            data-testid={`location-pill-${i}`}>
                            {p.mode === "walk" ? <Footprints size={20} className="text-[#C49A45]" /> : <Car size={20} className="text-[#C49A45]" />}
                            <p className="font-serif-d text-4xl mt-4">{p.time}</p>
                            <p className="text-xs uppercase tracking-[0.2em] text-white/60 mt-1">{p.mode} · {p.name}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
